import { CheckCircleIcon, XCircleIcon } from "lucide-react";
import { toast, ToastOptions } from "react-hot-toast";

const toastStyles = (color: string): React.CSSProperties => ({
  borderLeft: `6px solid ${color}`,
  borderRadius: "12px",
  padding: "10 12px",
  background: "#ffffff",
  color: "#1f2937",
  fontSize: "",
  fontWeight: "600",
  boxShadow:
    "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
});

const toastAnimation = "animate-scale-in";

export function successToast(message: string, options?: ToastOptions) {
  toast.dismiss();
  toast.success(message, {
    icon: <CheckCircleIcon className="text-green-600" size={22} />,
    style: toastStyles("#16a34a"),
    className: toastAnimation,
    ...options,
  });
}

export function errorToast(message: string, options?: ToastOptions) {
  toast.dismiss();
  toast.error(message, {
    icon: <XCircleIcon className="text-red-600" size={22} />,
    style: toastStyles("#dc2626"),
    className: toastAnimation,
    ...options,
  });
}

export function toastLoading(message: string, options?: ToastOptions) {
  const id = toast.loading(message, {
    style: toastStyles("#3b82f6"),
    className: toastAnimation,
    ...options,
  });

  const dismiss = (callback?: () => void) => {
    toast.dismiss(id);
    callback?.();
  };

  return {
    success: (message: string, options?: ToastOptions) =>
      dismiss(() => successToast(message, options)),
    error: (message: string, options?: ToastOptions) =>
      dismiss(() => errorToast(message, options)),
    dismiss,
  };
}
